import { Box, Flex } from 'dash-ui';
import styled from 'styled-components';

export const PropertyItemWrapper = styled(Flex)`
  background-color: ${({ theme }) => theme.colors.b5};
  cursor: pointer;
`;

export const LockIconBox = styled(Flex)`
  border-radius: ${({ theme }) => theme.space}px;
  background-color: ${({ theme }) => theme.colors.n30};
`;

export const ThumbnailWrapper = styled(Box)`
  border-radius: ${({ theme }) => theme.space}px;
`;

export const PropertyItemDetailsContainer = styled(Box)`
  display: inherit;
  @media ${({ theme }) => theme.devices.mobile} {
    display: none;
  }
`;

export const PropertyItemDetailsMobileContainer = styled(Flex)`
  display: none;
  @media ${({ theme }) => theme.devices.mobile} {
    display: flex;
  }
`;
